import ApartOne from 'componentsForThree/ApartOne';
import ApartThree from 'componentsForThree/ApartThree';
import ApartTwo from 'componentsForThree/ApartTwo';
import { limitOneVal, limitThreeVal, limitTwoVal } from 'constant/env';
import { useLayoutEffect, useState } from 'react';
type Props = {
  pos: Array<number>;
  value?: number;
};

export default function ApartTemplate({ pos, value = 0 }: Props) {
  const [bType, setType] = useState<number>(Math.floor(Math.random() * 9));
  const [bPrice, setPrice] = useState<number>(Math.floor(Math.random() * 10));

  return bType === 4 ? (
    <ApartTwo pos={pos} value={bPrice * limitTwoVal + limitTwoVal} />
  ) : bType === 3 ? (
    <ApartOne pos={pos} value={(bPrice + 1) * limitThreeVal} />
  ) : (
    <ApartThree pos={pos} value={bPrice * limitOneVal + limitOneVal * 2} />
  );
}
